// extracted by mini-css-extract-plugin
export var local_nav = "local-nav-module--local_nav--1Fnut";
export var local_nav_target = "local-nav-module--local_nav_target--3uRas";
export var Current = "local-nav-module----current--1eWiW";